// Vuex module — Persetujuan Retur (P26_045 FR-07).
//
// Halaman /offline-stores/pos-return. Endpointnya di routes/routes/unionweb.php grup
// `/pos-return`, dijaga auth:api + access (modul `posreturn_*`). Ketiga aksi tulis TIDAK
// menelan galat: penolakan 422 dari server ("Retur ini sudah diambil di toko.", dll) harus
// sampai ke layar apa adanya.
import $axios from "../../api";

const PREFIX = "unionweb/pos-return";

const emptyPage = () => ({ data: [], total: 0, per_page: 20, current_page: 1, last_page: 1, from: 0, to: 0 });
const emptyCounts = () => ({ menunggu: 0, disetujui: 0, ditolak: 0, selesai: 0, dibatalkan: 0 });

const state = () => ({
  isLoading: false,
  list: emptyPage(),
  counts: emptyCounts(),
  page: 1,
});

const mutations = {
  SET_LOADING(s, v) {
    s.isLoading = v;
  },
  SET_LIST(s, v) {
    s.list = v?.returns || emptyPage();
    s.counts = v?.counts || emptyCounts();
  },
  SET_PAGE(s, v) {
    s.page = v;
  },
};

const actions = {
  async getList({ commit, state, rootState, dispatch }, query = "") {
    commit("SET_LOADING", true);

    try {
      const res = await $axios.get(
        `${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${query}`
      );
      commit("SET_LIST", res.data?.data);

      return res.data;
    } catch (error) {
      commit("SET_LIST", null);
      dispatch("Main/globalSweetAlert", error.response || { message: "Unknown error" }, { root: true });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // Tidak disimpan di state: isinya milik satu modal.
  async getDetail(_ctx, uuid) {
    const res = await $axios.get(`${PREFIX}/detail`, { params: { uuid } });

    return res.data?.data || null;
  },

  async getStores() {
    const res = await $axios.get(`${PREFIX}/stores`);

    return res.data?.data?.stores || [];
  },

  async getDestinations() {
    const res = await $axios.get(`${PREFIX}/destinations`);

    return res.data?.data?.destinations || [];
  },

  async approve(_ctx, uuid) {
    const res = await $axios.post(`${PREFIX}/approve`, { uuid });

    return res.data?.data;
  },

  async reject(_ctx, { uuid, rejectReason }) {
    const res = await $axios.post(`${PREFIX}/reject`, { uuid, reject_reason: rejectReason });

    return res.data?.data;
  },

  async cancel(_ctx, uuid) {
    const res = await $axios.post(`${PREFIX}/cancel`, { uuid });

    return res.data?.data;
  },
};

export default { namespaced: true, state, mutations, actions };
